export default __webpack_public_path__ + "static/media/think-markets-logo-white.3bdda630.png";